import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles(theme => ({
  backLink: {
    display: "flex",
    width: "fit-content",
    color: colors.black,
    "&:hover,&:focus": {
      color: theme.palette.primary.main,
    },
  },
  backLinkIcon: {
    color: "inherit",
    "&:hover": {
      color: "inherit",
    },
  },
}));

export default useStyles;
